import { formatOdds } from '@/utils/format-odds';

import { useOddsFormat } from './use-odds-format';

// Format odds based on the user's odds format preference
export const useFormatOdds = (decimalOdds?: number, decimals = 2) => {
    const oddsFormat = useOddsFormat();
    return formatOdds(oddsFormat, decimalOdds, decimals);
};
